<ng-container *bizPermissionRequired="'Developer_Action_DocumentConfig_Edit'">
  @if (documentConfigId) {
    (<ep-link tooltip="View or edit the details for the document-config" linkUrl="/developer/docconfigs" [linkParms]="{ selectedDocumentConfigId: documentConfigId, documentConfigShowType: 'entity' }">View</ep-link>
    / <ep-link tooltip="View or edit the itinerary for the document-config" linkUrl="/developer/docconfigs" [linkParms]="{ selectedDocumentConfigId: documentConfigId, documentConfigShowType: 'itinerary' }">Itinerary</ep-link>)
  }
</ng-container>
